import { useState, useEffect } from 'react'

const REF_POINT = 300
export const ScrollToTopBtn = () => {
	const [isBtnShow, setIsBtnShow] = useState<boolean>(false)

	useEffect(() => {
		const handleScrollToTopBtnVisibility = () => {
			window.scrollY > REF_POINT ? setIsBtnShow(true) : setIsBtnShow(false)
		}

		window.addEventListener('scroll', handleScrollToTopBtnVisibility)

		return () => {
			window.removeEventListener('scroll', handleScrollToTopBtnVisibility)
		}
	}, [])

	const handleScrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}

	return (
		<div className={`go-top ${isBtnShow ? 'active' : ''}`}
		     onClick={handleScrollToTop}
		>
			<i className="ri-arrow-up-s-line"></i>
		</div>
	)
}
